import axios from "axios";

export const searchJobs = (careersClientId, jobs) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/jobs/searchJobs/" +
        encodeURIComponent(careersClientId) +
        "?refNumbers=" +
        encodeURIComponent(jobs)
    )
    .then((res) => res.data);
};
